import React, { useEffect, useState } from "react";
import AdminPanelUserList from "./AdminPanelUserList";
import AdminPanelProducts from "./AdminPanelProducts";
import AdminPanelOrders from "./AdminPanelOrders";
import AdminPanelTelegramBind from "./AdminPanelTelegramBind";
import { authFetch } from "utils/authFetch";
import { AdminApiProvider } from "./adminApi";

export default function AdminPanel() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("users");
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    authFetch("/api/accounts/profile/")
      .then(({ data, status }) => {
        if (status === 401) {
          setIsAdmin(false);
          return;
        }
        setUser(data);
        const role = Number(data.role_id);
        if (role === 2 || role === 3) {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      })
      .catch(() => setIsAdmin(false));
  }, []);

  const userRoleId = Number(user?.role_id);

  const adminTabs = [
    { key: "users", label: "Пользователи", roles: [3] },
    { key: "orders", label: "Заказы", roles: [2, 3] },
    { key: "products", label: "Товары и категории", roles: [2, 3] },
    { key: "telegram", label: "Telegram-бот", roles: [2, 3] },
  ];

  const tabClasses = (t) =>
    `px-4 py-2 border-b-2 ${
      tab === t ? "border-blue-600 font-bold" : "border-transparent"
    } cursor-pointer`;

  if (isAdmin !== true) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        {isAdmin === null ? (
          <p className="text-gray-500">Проверка доступа...</p>
        ) : (
          <p className="text-red-500 text-lg font-semibold">У вас нет прав для доступа к админке.</p>
        )}
      </div>
    );
  }

  return (
    <AdminApiProvider>
      <div className="p-4 sm:p-6">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">Админ-панель</h1>
      <div className="flex flex-wrap gap-2 sm:gap-4 border-b mb-6 overflow-x-auto whitespace-nowrap">
        {adminTabs
          .filter(tabObj => tabObj.roles.includes(userRoleId))
          .map(tabObj => (
            <div
              key={tabObj.key}
              className={tabClasses(tabObj.key)}
              onClick={() => setTab(tabObj.key)}
            >
              {tabObj.label}
            </div>
          ))}
      </div>
        {tab === "users" && <AdminPanelUserList />}
        {tab === "orders" && <AdminPanelOrders />}
        {tab === "products" && <AdminPanelProducts />}
        {tab === "telegram" && <AdminPanelTelegramBind />}
      </div>
    </AdminApiProvider>
  );
}
